// QuoteBlockEditor — block-style or pullquote-style quotation with
// optional attribution line.

import type { QuoteBlock, Block } from "../../../lib/blocks";
import { t } from "../theme";

export interface QuoteBlockEditorProps {
  block: QuoteBlock;
  onChange: (patch: Partial<Block>) => void;
  isSelected: boolean;
}

export function QuoteBlockEditor({
  block,
  onChange,
  isSelected,
}: QuoteBlockEditorProps) {
  const isPull = block.style === "pullquote";

  return (
    <div>
      {isSelected && (
        <div style={{ display: "flex", gap: 6, marginBottom: 6, fontFamily: t.sans }}>
          {(["block", "pullquote"] as const).map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => onChange({ style: s } as Partial<QuoteBlock>)}
              style={{
                padding: "3px 8px",
                fontSize: 11,
                borderRadius: 4,
                background: (block.style || "block") === s ? t.accentSoft : "transparent",
                color: (block.style || "block") === s ? t.accent : t.text3,
                border: `1px solid ${
                  (block.style || "block") === s ? t.accentStrong : t.border
                }`,
                cursor: "pointer",
                textTransform: "capitalize",
              }}
            >
              {s}
            </button>
          ))}
        </div>
      )}
      <div
        style={{
          borderLeft: isPull ? "none" : `3px solid ${t.accent}`,
          paddingLeft: isPull ? 0 : 16,
          fontFamily: t.serif,
          textAlign: isPull ? "center" : "left",
        }}
      >
        <textarea
          value={block.text}
          onChange={(e) => onChange({ text: e.target.value } as Partial<QuoteBlock>)}
          placeholder="A quotation"
          rows={2}
          style={{
            width: "100%",
            boxSizing: "border-box",
            background: "transparent",
            border: "none",
            outline: "none",
            resize: "vertical",
            fontFamily: t.serif,
            fontSize: isPull ? 26 : 20,
            fontStyle: "italic",
            lineHeight: 1.4,
            color: t.text,
            textAlign: isPull ? "center" : "left",
            padding: 0,
          }}
        />
        <input
          type="text"
          value={block.attribution || ""}
          onChange={(e) =>
            onChange({ attribution: e.target.value } as Partial<QuoteBlock>)
          }
          placeholder="— Attribution (optional)"
          style={{
            width: "100%",
            boxSizing: "border-box",
            background: "transparent",
            border: "none",
            outline: "none",
            fontFamily: t.sans,
            fontSize: 13,
            color: t.text3,
            marginTop: 8,
            textAlign: isPull ? "center" : "left",
            padding: 0,
          }}
        />
      </div>
    </div>
  );
}
